import React from 'react';

const ICON_ID = 'icon-city';

const IconCity = function(props) {
  return (
    <svg width="49" height="48" viewBox="0 0 49 48" aria-labelledby={ICON_ID}>
     <title id={ICON_ID}>City Icon</title>
      <g strokeWidth="1.143" fill="none" fillRule="evenodd">
        <path d="M24.096.572c12.987 0 23.513 10.487 23.513 23.425S37.083 47.422 24.096 47.422C11.111 47.422.584 36.935.584 23.997S11.111.572 24.096.572z" strokeLinejoin="round"/>
        <path d="M22.841 15.922v-5.477h8.823v27.103"/>
        <path d="M17.014 37.549V16.882l3.642-2.4 3.643 2.4v20.667M43.481 37.229H4.691M33.688 37.229v-9.154h5.544v9.474M9.406 37.229V23.078h5.584v14.47"/>
      </g>
    </svg>

  )
}

export default IconCity;



// WEBPACK FOOTER //
// ./src/client/components/icons/icon-city.jsx